import * as React from 'react';

export const TabContext = React.createContext({ selected: -1 });

export const useTab = () => React.useContext(TabContext);
